import {requestHelpers} from '../../../../../helpers';
import {updateTodoList} from '../../../../../actions/todo_list/todo_list';

export const actions = {
  SET_AWARDS: "SET_AWARDS",
  GENERAL_AWARDS_REQUEST: "GENERAL_AWARDS_REQUEST",
  GENERAL_AWARDS_SUCCESS: "GENERAL_AWARDS_SUCCESS",
  GENERAL_AWARDS_ERROR: "GENERAL_AWARDS_ERROR",
  DELETE_AWARDS_SUCCESS: "DELETE_AWARDS_SUCCESS"
};

export const setAwards = (profile) => {
  const noData = profile.awards.length === 0;
  return {
    type: actions.SET_AWARDS,
    personId: profile.id,
    body: profile.awards,
    noData
  }
};

export const awardsApiCall = (personId, payload, type, callbackToHOC) => {
  const requestType = type === 'CREATE' ? 'POST' : ( type === 'UPDATE' ? 'PUT' : 'DELETE' );
  const endpoint = type === 'CREATE' ? '' : ( payload.id ? `/${ payload.id }` : `/${ payload }`);

  const _payload = {...payload};

  if (requestType !== 'DELETE') {
    _payload.date = `${ payload.year.value }-0${ payload.month.value }`;

  }
  return (dispatch) => {
    dispatch({
      type: actions.GENERAL_AWARDS_REQUEST,
      isAwardsFetching: true,
      isAwardsError: false
    });

    requestHelpers
      .authenticatedPostRequest(`/profiles/${personId}/award${endpoint}`, _payload, requestType)
      .then((response) => {
        callbackToHOC();
        payload.hasOwnProperty('id') ? _payload.id = _payload.id || response.data.id : payload;
        return dispatch({
          type: requestType === 'DELETE' ? actions.DELETE_AWARDS_SUCCESS : actions.GENERAL_AWARDS_SUCCESS,
          personId,
          body: requestType === 'DELETE' ? payload : _payload,
          isAwardsFetching: false,
          isAwardsError: false
        })
      })
      .catch((error) => {
        callbackToHOC(error);
        return dispatch({
          type: actions.GENERAL_AWARDS_ERROR,
          isAwardsFetching: false,
          isAwardsError: true,
          error: error.status
        })
      })

    dispatch(updateTodoList(personId, 8));

  }
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/awards.js